<template lang="pug">

  uiv-dropdown(ref="dropdown-sino")
    a.to-click.main-header__button--category(@click="read" type="primary" class="dropdown-toggle")
      .icon-ptt-icons-sino
      span.badge(v-if="unread !== 0") {{unread}}
      span.badge(v-if="unread === 0 && !ready")
        .icon-ptt-icons-recarregar.icon-spin
      .arrow-img.icon-ptt-icons-dropdown

    template(slot="dropdown")
      li.lowercase(v-for="item in items")
        a(v-if="item.url" :href="item.url" target='_blank') {{item.name}}
        a(v-if="!item.url" style="display: flex; align-items: center")
          .icon-ptt-icons-recarregar.icon-spin(v-if="item.status==='STARTED'")
          .icon-ptt-icons-recarregar.icon-spin(v-if="item.status==='PENDING'")
          .icon-ptt-icons-X(v-if="item.status==='FAILURE'")
          span &nbsp; {{item.name}}
      li
        a.to-click.lowercase(role="button" @click="cleanQueueReports")
          | Limpar fila de relatórios
      li
        a.to-click.lowercase(v-if="showActivateNotification && notificationDisabled", role="button" @click="activateBrowserNotification")
          | Ativar notificações do navegador

</template>

<script>
import { differenceBy } from 'lodash'
import { setTimeout, clearTimeout } from 'timers'
import { mapState } from 'vuex'
import moment from 'moment'

window.vueNotificationStart = () => {
  window.vuex.state.notification.reportLoading = !window.vuex.state.notification.reportLoading
}

export default {
  props: {},
  data () {
    return {
      items: [],
      sessionUrl: [],
      unread: 0,
      delay: 20,
      delayTime: 0, // count until one minute
      ready: false,
      timer: null,
      first: true,
      waiting: false,
      showActivateNotification: true
    }
  },
  computed: {
    ...mapState('notification', ['reportLoading', 'lastNotification']),
    notificationDisabled () {
      return Notification.permission !== 'granted'
    }
  },
  mounted () {
    this.polling()
    window.vueNotificationStart()

    // watch for events
    this.$root.$on('Notifications__checkUserFiles', this.read)
  },
  methods: {
    async cleanQueueReports () {
      const { compMan, id } = this.$store.state.userInfo

      try {
        await this.$API.clearUserFile.get({ compManId: compMan.id, userId: id })
      } catch (e) {
        console.error(e)
      }
    },
    activateBrowserNotification () {
      Notification.requestPermission()
      this.showActivateNotification = false
    },
    polling () {
      if (!this.ready) {
        this.waiting = true
        this.$API.reports.get()
          .then(this.handleResponse)
          .catch(this.setPolling)
      } else {
        this.waiting = false
        clearTimeout(this.timer)
      }
    },
    read () {
      this.unread = 0
      this.delay = 20
      this.delayTime = 0

      // check for new content
      clearTimeout(this.timer) // cancel the last timer
      this.ready = false
      this.polling()
    },
    setPolling (error) {
      if (error.status === 403) this.ready = true
      this.timer = setTimeout(this.polling, this.delay * 1000) // check every delay time
    },
    handleResponse (response) {
      const { data, ready, error, info } = response.body.success

      this.ready = ready

      this.delayTime += 1
      if (this.delayTime === 6) this.delay = 30

      if (!this.first) this.handleData(data)

      this.handleErrorAndInfo(error, info)

      this.items = data
      this.first = false
      this.setPolling()
    },
    handleData (data) {
      const newData = differenceBy(data, this.items, 'url')

      newData.forEach(item => {
        if (!item.url) return

        let allowDownload = true

        if (Notification.permission !== 'granted') {
          Notification.requestPermission()
        } else {
          const notification = new Notification('Relatório Pontotel', {
            notificationId: 'avoidmultiple',
            tag: 1,
            icon: 'https://s3-sa-east-1.amazonaws.com/lar21css/logo_120x120.png',
            body: "O relatório '" + item.name + "' terminou de ser gerado."
          })

          notification.onclick = function () {
            window.open(item.url)
          }
        }

        this.unread += 1
        this.$uiv_notify({
          type: 'success',
          title: item.name
        })

        // var lastNotification = SessionService.getObject('lastNotification');
        const now = moment().format('YYYY-MM-DD HH:mm')

        if (this.lastNotification) {
          const lastMoment = moment(this.lastNotification)
          const nowMoment = moment(now)
          const diff = nowMoment.diff(lastMoment)
          const d = moment(diff).format('mm')

          if (d > 1) {
            allowDownload = true
          } else {
            allowDownload = false
          }
        }

        if (item === newData[0]) {
          this.$store.commit('notification/setLastNotificationNow')
          // SessionService.setObject('lastNotification', now);
        }

        if (allowDownload) {
          const link = document.createElement('a')
          link.download = item.name
          link.href = item.url
          link.click()
        }
      })
    },
    handleErrorAndInfo (error, info) {
      if (error.length) console.warn(error)
      if (info) console.log(info)

      error.forEach(e => {
        const errMsg = e.error
          ? `${e.error}\nEntre em contato suporte@pontotel.com.br`
          : 'Erro ao gerar Relatório, entre em contato: suporte@pontotel.com.br'

        this.$uiv_notify({
          type: 'danger',
          title: e.name,
          content: errMsg
        })
      })

      if (info) {
        this.$uiv_notify({
          type: 'info',
          content: info
        })
      }
    }
  },
  watch: {
    reportLoading: function () {
      this.delay = 20
      this.delayTime = 0

      if (!this.waiting) {
        this.ready = false
        setTimeout(this.polling, 3 * 1000) // wait 3 seconds to try to get the report
      }
    }
  },
  beforeDestroy () {
    // Cancel pending timeouts
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.main-header__button--category {
  color: var(--front-color-font-header);
  text-overflow: ellipsis;
  text-shadow: none;
  white-space: nowrap;
  font-weight: 300;
  font-size: 1em;
  display: flex;
}
.main-header__button--category:hover,
.open .main-header__button--category {
  /*font-weight: bold;*/
  /* border-bottom-width: 2px;
  border-bottom-style: solid; */
  /*border-bottom-color: var(--color-primary);*/
  padding: 8px;
  /*color: var(--color-primary);*/
}
.arrow-img {
  position: relative;
  top: 0px;
  left: 2px;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: normal;
  color: var(--front-color-header);
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: var(--front-color-font-header);
  border-radius: 10px;
  margin-left:5px;
}

.icon-spin {
  animation-name: spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>
